import { HeadlineVizPropVersion } from '../types/prism';
export const HEADLINE_CLIENT_STATE_LATEST_VERSION = HeadlineVizPropVersion.V1;
export function upgradeHeadlineClientState(vizModel) {
    const vizProp = vizModel.vizProps;
    if (vizProp &&
        vizProp.headlineVizPropVersion === HEADLINE_CLIENT_STATE_LATEST_VERSION) {
        return vizProp;
    }
    return {
        __typename: 'HeadlineVizProps',
        headlineVizPropVersion: HeadlineVizPropVersion.V1,
        columnProperty: null,
    };
}
export const initHeadlineClientState = (vizModel) => ({
    __typename: 'HeadlineVizProps',
    columnProperty: null,
    headlineVizPropVersion: HEADLINE_CLIENT_STATE_LATEST_VERSION,
});
//# sourceMappingURL=headline-client-state-util.js.map